const LOGO_SRC = "/dpm-logo-transparent.png";

export const SpinningLogo = () => (
  <div
    data-testid="spinning-logo"
    className="logo-stage w-[260px] h-[260px] sm:w-[340px] sm:h-[340px] lg:w-[420px] lg:h-[420px]"
  >
    <div className="logo-glow" />
    <div className="logo-spinner">
      <img src={LOGO_SRC} alt="Defense Precision Machining logo" className="logo-face" draggable="false" />
      <img src={LOGO_SRC} alt="" aria-hidden="true" className="logo-face logo-face--back" draggable="false" />
    </div>
  </div>
);
